export const data = {
    categories: [
        { _id: 1, category: "Men" },
        { _id: 2, category: "Women" },
        { _id: 3, category: "Kids" },
    ],

    subcategories: {
        men: [
            { _id: 1, subcategory: "Shirts" },
            { _id: 2, subcategory: "T-Shirts" },
            { _id: 3, subcategory: "Jeans" },
        ],
        women: [
            { _id: 1, subcategory: "Top" },
            { _id: 2, subcategory: "T-Shirts" },
            { _id: 3, subcategory: "Shirts" },
            { _id: 4, subcategory: "Jeans" },
            { _id: 5, subcategory: "Kurti" },
        ],
        kids: [
            { _id: 1, subcategory: "Shirts" },
            { _id: 2, subcategory: "T-Shirts" },
            { _id: 3, subcategory: "Jeans" },
        ],
    },

    brands: {
        kids: [
            { _id: "1", brand: "Adidas" },
            { _id: "2", brand: "GapKids" },
            { _id: "3", brand: "Levi's Kids" },
            { _id: "4", brand: "Nike Kids" },
            { _id: "5", brand: "H&M Kids" },
            { _id: "6", brand: "Old Navy Kids" },
            { _id: "7", brand: "Puma Kids" },
            { _id: "8", brand: "Carter's" },
            { _id: "9", brand: "GAP Kids" },
            { _id: "10", brand: "Tommy Hilfiger Kids" },
            { _id: "11", brand: "Polo Ralph Lauren Kids" },
        ],
        women: [
            { _id: "1", brand: "Zara" },
            { _id: "2", brand: "Nike" },
            { _id: "3", brand: "Ralph Lauren" },
            { _id: "4", brand: "Levi's" },
            { _id: "5", brand: "Sabyasachi" },
            { _id: "6", brand: "H&M" },
            { _id: "7", brand: "Adidas" },
            { _id: "8", brand: "Tommy Hilfiger" },
            { _id: "9", brand: "Guess" },
            { _id: "10", brand: "Anita Dongre" },
            { _id: "11", brand: "Forever 21" },
            { _id: "12", brand: "Puma" },
            { _id: "13", brand: "GAP" },
            { _id: "14", brand: "Wrangler" },
            { _id: "15", brand: "Biba" },
        ],
        men: [
            { _id: "1", brand: "Brooks Brothers" },
            { _id: "2", brand: "Nike" },
            { _id: "3", brand: "Levi's" },
            { _id: "4", brand: "Ralph Lauren" },
            { _id: "5", brand: "H&M" },
            { _id: "6", brand: "Wrangler" },
            { _id: "7", brand: "Tommy Hilfiger" },
            { _id: "8", brand: "Gap" },
            { _id: "9", brand: "Calvin Klein" },
            { _id: "10", brand: "American Eagle" },
            { _id: "11", brand: "Zara" },
            { _id: "12", brand: "Diesel" },
            { _id: "13", brand: "Topman" },
            { _id: "14", brand: "Lacoste" },
            { _id: "15", brand: "GAP" },
            { _id: "16", brand: "J.Crew" },
            { _id: "17", brand: "Banana Republic" },
            { _id: "18", brand: "Hudson" },
            { _id: "19", brand: "Carhartt" },
        ],
    },
    sizes: [
        { _id: "1", size: "S" },
        { _id: "2", size: "M" },
        { _id: "3", size: "L" },
        { _id: "4", size: "XL" },
        { _id: "5", size: "4" },
        { _id: "6", size: "5" },
        { _id: "7", size: "6" },
        { _id: "8", size: "7" },
        { _id: "9", size: "8" },
        { _id: "10", size: "9" },
        { _id: "11", size: "10" },
        { _id: "12", size: "11" },
        { _id: "13", size: "12" },
    ],
};